export const deliveryTypeOptions = [
  {
    value: 'Default',
    label: 'Standard',
  },
  {
    value: 'Pay-On-Delivery',
    label: 'Cash on delivery',
  },
  {
    value: 'Postal-Service',
    label: 'Postal service',
  },
];
